import RefluencedLogo from "@/assets/images/refluenced.svg";
import {useLocation, useNavigate} from "@tanstack/react-router";
import {useEffect, type ComponentType} from "react";
import {type FallbackProps} from "react-error-boundary";
import {useTranslation} from "react-i18next";
import {usePrevious} from "react-use";

const ErrorPage: ComponentType<FallbackProps> = ({resetErrorBoundary}) => {
  const {t} = useTranslation("common");
  const location = useLocation();
  const navigate = useNavigate();
  const prevLoc = usePrevious(location.pathname);

  useEffect(() => {
    if (prevLoc && prevLoc !== location.pathname) resetErrorBoundary?.();
  }, [location.pathname, prevLoc, resetErrorBoundary]);

  return (
    <div
      style={{minHeight: "50vh"}}
      className="text-neutral-black flex h-1/2 flex-col items-center justify-center gap-2 px-20">
      <div className="h-48 shrink-0 cursor-pointer pb-6" onClick={() => navigate({to: "/"})}>
        <img src={RefluencedLogo} className="size-full object-contain" />
      </div>
      <span className="text-center text-3xl font-medium">{t("unknownError")}</span>
      <span className="text-neutral-grey-dark text-center text-lg font-medium">
        {t("Please try again later. If the problem persists, please contact support")}
      </span>
    </div>
  );
};

export default ErrorPage;
